import FeatureData from './FeatureData';


/**
 * Object to store feature/track data.
 *
 * Data type:
 * - 'route'
 * - 'stage'
 *
 * Los campos track_* los rellenan las factorias de las subclases a partir de
 * las propiedades del feature del tileset.
 * @see StageData.fromMapFeature
 */
class TrackData extends FeatureData {
    // Id track
    track_id?: string;
    // Id route
    route_id?: string;
    // Id route
    camino_id?: string;
    // Number of track
    track_number?: string;
    // Title route
    track_title?: string;
    // Is selected
    selected = false;

    /**
     * Set selected state.
     *
     * No devuelve nada, pese a lo que decia el JSDoc original: solo guarda el
     * estado. La que si devuelve boolean es PlaceData.setSelected.
     */
    setSelected(selected = true): void {
      this.selected = selected;
    }

}

export default TrackData;
